<template>
  <div class="exclusive-offer-container">
    <div class="content-wrapper">
      <div class="header-section">
        <img
          class="logo"
          src="@website-assets/img/logo-stowy.png"
          alt="Stowy Logo"
          @click="goHome"
        />
        <div class="starry-decoration">
          <img src="@website-assets/img/starry.png" alt="" />
        </div>
      </div>

      <div class="main-content">
        <h1 class="title">{{ $t('exclusiveOffer.title') }}</h1>
        <h2 class="subtitle">{{ $t('exclusiveOffer.subtitle') }}</h2>

        <div class="intro-text">
          <p class="intro-main">{{ $t('exclusiveOffer.intro') }}</p>
          <p class="intro-description">{{ $t('exclusiveOffer.description') }}</p>
        </div>

        <div class="cta-buttons">
          <button
            class="btn btn-primary btn-L"
            @click="goToSurvey"
          >
            {{ $t('exclusiveOffer.start-survey') }}
          </button>

          <button
            class="btn btn-secondary btn-L skip-btn"
            @click="goToOffers"
          >
            {{ $t('exclusiveOffer.skip-survey') }}
          </button>
        </div>
      </div>

      <footer class="footer-links">
        <a href="/">{{ $t('global.close') }}</a>
      </footer>
    </div>

    <!-- Popup intersticielle -->
    <div v-if="showPopup" class="popup-overlay" @click="closePopup">
      <div class="popup-content" @click.stop>
        <h2 class="popup-title">{{ $t('exclusiveOffer.popup-title') }}</h2>
        <p class="popup-message">{{ $t('exclusiveOffer.popup-message') }}</p>
        <p class="popup-importance">{{ $t('exclusiveOffer.popup-importance') }}</p>

        <div class="popup-buttons">
          <button class="btn btn-primary btn-L" @click="goToSurveyFromPopup">
            {{ $t('exclusiveOffer.popup-cta-survey') }}
          </button>
          <button class="btn btn-secondary btn-L" @click="goToOffersConfirmed">
            {{ $t('exclusiveOffer.popup-cta-skip') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useHead } from '@unhead/vue'

export default {
  name: 'ExclusiveOffer',
  setup() {
    useHead({
      title: 'Offres Exclusives Stowy - Jusqu\'à -50% sur l\'abonnement',
      meta: [
        // Meta Description
        {
          name: 'description',
          content: 'Profitez d\'offres exclusives Stowy : réductions jusqu\'à -50% ou abonnements à vie ! Histoires personnalisées pour enfants avec des tarifs exceptionnels.'
        },

        // Keywords for SEO
        {
          name: 'keywords',
          content: 'offres Stowy, réduction Stowy, abonnement Stowy, histoires personnalisées enfants, promotion Stowy, offre exclusive'
        },

        // Open Graph (OG) Tags for social media sharing
        {
          property: 'og:title',
          content: 'Offres Exclusives Stowy - Jusqu\'à -50% 🎁'
        },
        {
          property: 'og:description',
          content: 'Bénéficiez de réductions jusqu\'à -50% sur l\'abonnement Stowy ou accédez à des formules à vie ! Histoires personnalisées pour vos enfants à prix réduits.'
        },
        {
          property: 'og:image',
          content: 'https://www.stowy.fr/assets/img/illu3a.png'
        },
        {
          property: 'og:url',
          content: 'https://www.stowy.fr/offre-exclusive'
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:site_name',
          content: 'Stowy'
        },

        // Twitter Card Tags
        {
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          name: 'twitter:title',
          content: 'Offres Exclusives Stowy - Jusqu\'à -50% 🎁'
        },
        {
          name: 'twitter:description',
          content: 'Profitez d\'offres exclusives : réductions jusqu\'à -50% ou abonnements à vie sur Stowy !'
        },
        {
          name: 'twitter:image',
          content: 'https://www.stowy.fr/assets/img/illu3a.png'
        }
      ]
    })
  },
  data() {
    return {
      showPopup: false
    };
  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
    goToSurvey() {
      this.$router.push('/offre-exclusive/questionnaire');
    },
    goToSurveyFromPopup() {
      this.showPopup = false;
      this.$router.push('/offre-exclusive/questionnaire');
    },
    goToOffers() {
      // Afficher la popup au lieu d'aller directement aux offres
      this.showPopup = true;
    },
    goToOffersConfirmed() {
      this.showPopup = false;
      this.$router.push('/offre-exclusive/offres');
    },
    closePopup() {
      this.showPopup = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style/vars/index";

.exclusive-offer-container {
  min-height: 100vh;
  background: linear-gradient(180deg, #f8f9ff 0%, #ffffff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.content-wrapper {
  max-width: 800px;
  width: 100%;
  position: relative;
}

.header-section {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;

  .logo {
    width: min(200px, 40vw);
    cursor: pointer;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }

  .starry-decoration {
    position: absolute;
    top: -50px;
    right: -50px;
    opacity: 0.3;
    width: 150px;
    pointer-events: none;

    img {
      width: 100%;
      height: auto;
      display: block;
    }

    @media (max-width: 768px) {
      display: none;
    }
  }
}

.main-content {
  background: white;
  border-radius: 30px;
  padding: min(4rem, 8vw);
  box-shadow: 0px 10px 40px rgba(77, 160, 255, 0.15);
  text-align: center;
}

.title {
  font-family: "Baloo 2", sans-serif;
  font-size: min(3rem, 8vw);
  font-weight: 700;
  color: #4da0ff;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.subtitle {
  font-family: "Baloo 2", sans-serif;
  font-size: min(1.8rem, 5vw);
  font-weight: 600;
  background: linear-gradient(90deg, #4DA0FF 0%, #7B4FD4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 2.5rem;
}

.intro-text {
  margin-bottom: 3rem;

  .intro-main {
    font-family: "Baloo 2", sans-serif;
    font-size: min(1.3rem, 4vw);
    color: #333;
    margin-bottom: 1.5rem;
    line-height: 1.6;
    font-weight: 500;
  }

  .intro-description {
    font-family: "Baloo 2", sans-serif;
    font-size: min(1.1rem, 3.5vw);
    color: #666;
    line-height: 1.6;
    font-weight: 400;
  }
}

.cta-buttons {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;

  .btn {
    width: 100%;
    max-width: 400px;
    font-size: min(1.5rem, 5vw);
    padding: 1.2rem 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.4;

    &.skip-btn {
      opacity: 0.8;
      font-size: min(1.3rem, 4.5vw);
    }
  }

  @media (min-width: 768px) {
    .btn {
      width: auto;
      min-width: 300px;
      font-size: 1.5rem;

      &.skip-btn {
        font-size: 1.3rem;
      }
    }
  }
}

.footer-links {
  text-align: center;
  margin-top: 2rem;

  a {
    font-family: "Baloo 2", sans-serif;
    color: #7B4FD4;
    text-decoration: none;
    font-size: 1rem;
    transition: color 0.3s ease;

    &:hover {
      color: #4da0ff;
    }
  }
}

@media (max-width: 768px) {
  .exclusive-offer-container {
    padding: 1rem;
  }

  .main-content {
    padding: 2rem 1.5rem;
  }
}

// Popup intersticielle
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.popup-content {
  background: white;
  border-radius: 30px;
  padding: min(3rem, 6vw);
  max-width: 600px;
  width: 100%;
  box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.4s ease;
  text-align: center;
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.popup-title {
  font-family: "Baloo 2", sans-serif;
  font-size: min(2rem, 6vw);
  font-weight: 700;
  color: #4da0ff;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.popup-message {
  font-family: "Baloo 2", sans-serif;
  font-size: min(1.2rem, 4vw);
  color: #333;
  line-height: 1.6;
  margin-bottom: 1rem;
  font-weight: 500;
}

.popup-importance {
  font-family: "Baloo 2", sans-serif;
  font-size: min(1.1rem, 3.5vw);
  color: #666;
  line-height: 1.6;
  margin-bottom: 2rem;
  font-weight: 400;
  font-style: italic;
}

.popup-buttons {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;

  .btn {
    width: 100%;
    max-width: 400px;
    font-size: min(1.3rem, 4.5vw);
    padding: 1.2rem 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.4;
  }

  @media (min-width: 768px) {
    .btn {
      font-size: 1.3rem;
    }
  }
}

@media (max-width: 768px) {
  .popup-content {
    padding: 2rem 1.5rem;
  }

  .popup-title {
    font-size: 1.5rem;
  }

  .popup-message {
    font-size: 1rem;
  }

  .popup-importance {
    font-size: 0.9rem;
  }
}
</style>
